import React from "react";
import "./style.css";
import { Input } from "antd";

const InputComp = (props) => {
  return (
    <div className="input-wrap">
      {props.label && <label>{props.label}</label>}
      {props?.type === "password" ? <Input.Password
        placeholder={props.placeholder}
        onChange={
          props?.onChange ? props?.onChange : props?.formik?.handleChange
        }
        name={props?.name}
        type={props?.type ? props?.type : "text"}
      /> :
        <Input
          placeholder={props.placeholder}
          onChange={
            props?.onChange ? props?.onChange : props?.formik?.handleChange
          }
          name={props?.name}
          type={props?.type ? props?.type : "text"}
          maxLength={props.maxLength}
        />}
      {props?.formik?.errors?.[props.name] &&
        props?.formik?.touched?.[props.name] && (
          <div className="error">{props?.formik?.errors?.[props.name]}</div>
        )}
      {/* {props.error} */}
    </div>
  );
};

export default InputComp;
